import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

const ClickSubmitButton = (props) => {
  const clickStatus = props.clickDetails.clickStatus;

  return (
    <div className="gray-container-centered">
      <Button
        className="gray-container-centered-button autotest-submit-button"
        id="click-submit-button"
        onClick={(event) => {
          props.storeClickGatewayDetails({
            clickStatus: true,
          });
          window.paymarkPlugin.submitPayment(event);
        }}
        disabled={clickStatus}
      >
        Submit
      </Button>
    </div>
  );
};

ClickSubmitButton.propTypes = {
  clickDetails: PropTypes.object,
  storeClickGatewayDetails: PropTypes.func
};

export default ClickSubmitButton;



/** WEBPACK FOOTER **
 ** ./src/components/clickPayment/ClickSubmitButton.js
 **/